import Actions from '../../actions/actions'

export default function createSocketMiddleware(socket) {
  // Socket param is the client. 
  return ({dispatch, getState}) => next => action => {
    if (typeof action === 'function') {
      return action(dispatch, getState)
    }

    /*
     * Socket middleware usage.
     * promise: (socket) => socket.emit('MESSAGE', 'hello world!')
     * type: always 'socket'
     * types: [REQUEST, SUCCESS, FAILURE]
     */
    const { promise, type, types, ...rest } = action

    if (type !== Actions.SOCKET || !promise) {
      // Move on! Not a socket request or a badly formed one.
      return next(action)
    }
    console.log('socket middleware action')
    console.log(socket)
    const [REQUEST, SUCCESS, FAILURE] = types
    next({...rest, type: REQUEST})

    return promise(socket)
      .then((result) => {
        return next({...rest, result, type: SUCCESS })
      })
      .catch((error) => {
        return next({...rest, error, type: FAILURE })
      })
  }
}
